<template>
    <div id="auth"
         class="full-size"
    >
        <img src="~images/loading.svg"
             v-show="!data.isShowForm"
        >
        <div id="form-auth-container"
             v-show="data.isShowForm"
             :class="data.classFormContainer"
        >
            <div class="head">
                <img id="logo" src="~/images/logo.png">
            </div>
            <form id="form-auth">
                <label>
                    <input
                        id="input-username"
                        :placeholder="i18n.t('label_enter_username')"
                        v-model="data.username"
                        @keyup="onInputKeyUp"
                        type="text"
                    >
                </label>
                <label>
                    <input
                        id="input-password"
                        :placeholder="i18n.t('label_enter_password')"
                        v-model="data.password"
                        @keyup="onInputKeyUp"
                        type="password"
                    >
                </label>
                <div class="error" v-if="data.errMsg!==''"> {{ i18n.t(data.errMsg)}}</div>
                <div class="help-center">
                    <span class="icon">i</span>
                    <a :href="`${config.links[envMode]['helpCenter'][i18n.locale.value]}`"
                       target="_blank"
                     >
                       {{ i18n.t("label_help_center") }}
                    </a>
                </div>
                <div class="form-btn-container">
                    <a id="btn-auth"
                       class="hover-effect"
                       @click.prevent="submit"
                       href="#"
                    >
                        {{ i18n.t("label_login") }}
                    </a>
                    <a id="btn-register"
                        class="hover-effect"
                        :href="`${mpmsDomain}/${i18n.locale.value}/${config.links[envMode].register}`"
                        target="_blank"
                    >
                        {{ i18n.t("label_register") }}
                    </a>
                </div>
                <p> {{ i18n.t("label_bestview") }}</p>
                <div id="version-download-wrapper">
                <version-download-control v-if="!isTouchDevice()"></version-download-control>
                </div>
            </form>
            <div class="menu">
                <a id="btn-lang"
                   class="hover-effect"
                   href="#"
                   :title="i18n.t('label_language')"
                   @click.prevent="changeLang()"
                > {{ i18n.t("label_home_lang") }}
                </a>
                <a id="btn-info"
                   class="hover-effect"
                   :title="i18n.t('tooltip_info')"
                   href="#"
                   @click.prevent="data.isShowInfo = !data.isShowInfo"
                >
                    i
                </a>
                <simple-list
                        :arrowHorizontalPosition="'right'"
                        :arrowVerticalDirection="'up'"
                        :isToggle="data.isShowInfo"
                        :stylePos="data.styleInfo"
                        :triggerId="'btn-info'"
                        @hidden="onInfoHidden"
                >
                    <links></links>
                </simple-list>
            </div>
        </div>
        <div class="copyright"> {{ i18n.t("info_copyright")}}</div>
        <tablet-version-popup v-if="data.ssoResult ||  (isTouchDevice() && !data.ssoResult && !data.loggedOut)"
                              :paramSsoToken="data.paramSsoToken"
                              :paramPage="data.paramPage"
                              :paramEbookcode="data.paramEbookcode"
        >
        </tablet-version-popup>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUnmounted, onUpdated, watchEffect, watch, computed,nextTick, inject}  from "vue";
    import {authenticate, handleSSO} from "@/modules/api/auth";
    import {changeLang} from "@/modules/i18n/i18n";
    import SimpleList from "@/views/lib/listing/SimpleList";
    import VersionDownloadControl from "@/views/versionSelect/VersionDownloadControl";
    import TabletVersionPopup from "@/views/versionSelect/TabletVersionPopup";
    import Links from "@/views/template/Links";
    import router from "@/router"
    import config from "@/config/config.json";
    import {isTouchDevice} from "@/modules/utils/deviceUtils";

    export default {
        components:{
            SimpleList,
            Links,
            VersionDownloadControl,
            TabletVersionPopup
        },
        setup(props, context) {

            const data = reactive({
                isShowForm:false,
                isDisappearForm:false,
                username:"",
                password:"",
                errMsg:"",
                styleInfo:{
                    top: "35px",
                    right: "-9px",
                    minWidth:"230px"
                },
                isShowInfo:false,
                classFormContainer:computed(()=>{
                    return {
                        "form-disappear":data.isDisappearForm
                    }
                }),
                paramSsoToken:null,
                paramEbookcode:null,
                paramPage:null,
                ssoResult:null,
                loggedOut:false
            })

            const i18n = inject('i18n');
            const refForm = ref(null);

            //TODO: validation and error handling!
            const submit = () =>{


                if (data.username === "" || data.password === "") {
                    data.errMsg = "error_msg_login_no_credentials";
                    return;
                }

                data.isDisappearForm = true;

                setTimeout(async () => {
                    data.isShowForm = false;
                    try {
                        await authenticate(data.username, data.password);
                        let redirect = router.currentRoute.value.query.redirect;
                        if (redirect) {
                            router.push(redirect)
                        } else {
                            router.push("home")
                        }
                    } catch (error) {
                        data.errMsg = error.message;
                        data.isShowForm = true;
                        //need to wait for data.isShowForm to update, so apply setTimeout
                        nextTick(()=> {
                            setTimeout(()=> {
                                data.isDisappearForm = false
                            },100);
                        });

                    }
                }, 600);

            }

            const onKeyUp = (e)=> {
                if (e.code === "Enter") {
                    submit();
                }
            }


            onMounted(async ()=>{

                setTimeout(()=>{
                    document.getElementById("input-username").focus();
                }, config.elementControl.focusTimeout)

                document.addEventListener('keyup', onKeyUp);

                console.log("@login mounted 0918");
                console.log(router)
                console.log(router.currentRoute);
                console.log(router.currentRoute.value.query);

                data.paramSsoToken = router.currentRoute.value.query.access_token;
                data.paramEbookcode  = router.currentRoute.value.query.ebookcode;
                data.paramPage = router.currentRoute.value.query.page;
                data.loggedOut = router.currentRoute.value.query.loggedOut;

                data.isShowForm = data.paramSsoToken === undefined;

                if (data.paramSsoToken) {

                    try {
                        data.ssoResult = await handleSSO(data.paramSsoToken);
                    } catch(e) {
                        alert(i18n.t("error_msg_invalid_token"))
                        location.href= `${window.location.origin}${window.location.pathname}`
                    }

                }

            })

            const onInputKeyUp = (e)=>{
                if (data.errMsg !== "") {
                    data.errMsg = "";
                }
            }

            const onInfoHidden = ()=>{
                data.isShowInfo = false;
            }

            onUnmounted(()=>{
                //remark: the key up listener must be removed here since it's added by document.The listener  won't be removed automatically
                document.removeEventListener('keyup', onKeyUp);
            })

            return {
                envMode:process.env.VUE_APP_MODE,
                mpmsDomain:process.env.VUE_APP_MPMS_DOMAIN,
                data,
                config,
                i18n,
                refForm,
                changeLang,
                onInfoHidden,
                onInputKeyUp,
                submit,
                isTouchDevice
            }
        }
    }

</script>

<style scoped lang="scss">

    $border-radius:10px;

    #auth {
        background:url("~images/bg_login.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        display:flex;
        align-items:center;
        justify-content:center;
    }

    #form-auth {
        padding: 10% 20% 10% 20%;
        background: $color-primary-light;
        border-radius: 0 0 $border-radius $border-radius;
        border:1px solid $border-color-primary;
        border-top:none;
        color:$text-color-primary;

        p {
            text-align: center;
        }
    }

    #form-auth-container {

        height:400px;
        width:85%;
        max-width:640px;
        border-radius:0 0 $border-radius $border-radius;
        position:relative;
        @include transition(all, 0.6s);

        .head {
            background: $color-primary;
            padding: 20px;
            display: flex;
            justify-content: center;
            border-radius: 10px 10px 0 0;
            border:1px solid $border-color-primary;
            border-bottom:none;
        }

        #logo {
            width:280px;
            height:34px;
        }

        input {
            width: 100%;
            margin:0 0 15px 0;
        }
    }

    .form-disappear {
        opacity:0;
        margin-top:-100%
    }

    .form-btn-container {
        display:flex;
        justify-content: center;
        margin:30px 0;

        a {
            width: 80px;
            height: 10px;
            padding: 15px;
            border-radius: 5px;
            text-align: center;
            line-height: 8px;
            margin: 0 10px;
            font-size: 16px;
        }

    }

    #btn-auth {
        @include btn-gradient($color-gradient-green-start, $color-gradient-green-end, #fff);
    }

    #btn-register {
        @include btn-gradient($color-gradient-grey-start, $color-gradient-grey-end, #000);
    }

    .menu {
        position:absolute;
        top: -32px;
        right: 4px;
        display:flex;

        & > a {
            background: linear-gradient(to bottom, $color-gradient-green-start 20%,  $color-gradient-green-end 80%) !important;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            text-align: center;
            color: #fff;
            font-weight: 400;
            line-height: 1.4em;
            margin: 0 0 0 8px;
            box-shadow: 2px 2px 5px #333;
        }

        .list-info {
            top: 36px;
            right: -7px;
            width:120px;
        }
    }

    .error {
        margin: 0 0 30px 0;
    }

    .help-center {
        width:100%;
        display:flex;
        justify-content:center;

        .icon {
            background: $color-primary !important;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            text-align: center;
            color: #fff;
            font-weight: 400;
            line-height: 1.4em;
            margin:0 8px;
        }

        a {
            color:$color-primary;
            font-size:14px;
            &:hover {
                color:$color-primary-bright;
            }

        }
    }

    .copyright {
        position:fixed;
        bottom:10px;
        width:100%;
        text-align:center;
    }

    .best-view {
        font-size:15px;
        position: relative;
        bottom: -90px;
        left:0;
        width: 100%;
        text-align: center;
    }



</style>